var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifier = function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.25 7.875a7.125 7.125 0 1 1 12.666 4.48l2.755 2.755a.75.75 0 0 1-1.061 1.06l-2.755-2.754A7.125 7.125 0 0 1 1.25 7.876M8.375 2.25a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25",
    clipRule: "evenodd"
  })));
};
export default SvgMagnifier;